import { isBuildEnv } from './env';

/**
 * ビルド環境ではそのままリダイレクトするが、
 * 開発環境ではドメインごとに生成する
 */
export const relativePath = (path: string, domain: string) => {
  if (isBuildEnv()) {
    return path;
  }
  if (path.startsWith('/')) {
    return `/${domain}${path}`;
  }
  return path;
};
